import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { EASE } from "@/components/motion";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("hw_token", data.token);
      toast.success("Willkommen zurück!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err, "Anmeldung fehlgeschlagen"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-forest-dark grain relative flex items-center justify-center px-4" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: EASE }}
        className="w-full max-w-md bg-sand rounded-3xl p-8 sm:p-10 shadow-2xl"
      >
        <img src="/logo.png" alt="Hotel Wildpferd" className="h-20 w-auto" />
        <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-terra">Admin-Bereich</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="flex flex-col gap-2">
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink/50">E-Mail</span>
            <input type="email" required data-testid="admin-email-input" value={email} onChange={(e) => setEmail(e.target.value)}
              className="rounded-xl border border-forest/15 bg-white px-4 py-3 text-sm outline-none focus:border-gold" placeholder="admin@hotel-wildpferd.de" />
          </label>
          <label className="flex flex-col gap-2">
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink/50">Passwort</span>
            <input type="password" required data-testid="admin-password-input" value={password} onChange={(e) => setPassword(e.target.value)}
              className="rounded-xl border border-forest/15 bg-white px-4 py-3 text-sm outline-none focus:border-gold" placeholder="••••••••" />
          </label>
          <button type="submit" data-testid="admin-login-submit" disabled={busy}
            className="w-full rounded-full bg-forest text-sand py-3.5 text-sm font-semibold hover:bg-forest-dark disabled:opacity-50 transition-colors duration-300">
            {busy ? "Anmelden …" : "Anmelden"}
          </button>
        </form>
        <Link to="/" className="mt-6 block text-center text-xs text-ink/50 hover:text-forest transition-colors" data-testid="admin-login-back-link">
          ← Zurück zur Website
        </Link>
      </motion.div>
    </main>
  );
}
